window.home =
{
    init: function ()
    {
        var hotspots = document.querySelectorAll(".swiper-slide div[data-bs-toggle='popover']");

        if (!hotspots)
            return;

        for (var hotspot of hotspots)
        {
            hotspot.addEventListener("inserted.bs.popover", () =>
            {
                home.swiperPopover(hotspot);
            });
        }
    },
    triggerPopover: function (sender)
    {
        var popover = bootstrap.Popover.getOrCreateInstance(sender);

        var isVisible = popover && sender.getAttribute("aria-describedby") !== null;

        if (!isVisible)
            popover.toggle();

        //popover.addEventListener("inserted.bs.popover", () =>
        //{
        //    home.swiperPopover(popover);
        //});
    },
    swiperPopover: function (hotspot)
    {
        var guid = hotspot.dataset.bsHtmlTarget;
        var popoverId = hotspot.getAttribute("aria-describedby");

        var element = document.getElementById(guid);

        if (!element)
            return;

        var popover = document.getElementById(popoverId);

        if (!popover)
            return;

        var body = popover.querySelector(".popover-body");

        if (!body)
            return;

        body.innerHTML = element.innerHTML;
    }
};